/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckCreateInvestmentRequestPaymentOption } from './deck-create-investment-request-payment-option';
import { InvestmentStatusEnum } from './investment-status-enum';

export interface DeckCreateInvestmentRequest {
  amount?: string | null;
  pitch: string;
  status?: InvestmentStatusEnum;
  equity_received?: number | null;
  investment_company?: string | null;
  contact_email?: string;
  payment_option?: DeckCreateInvestmentRequestPaymentOption | null;
  account_number?: string | null;
  vps?: string | null;
  compensation?: string | null;
  user: string;
}
export namespace DeckCreateInvestmentRequest {}
